import React from "react";
import PageHeader from "@/components/PageHeader";
import Services from "@/components/Services";
import WhyChooseUs from "@/components/WhyChooseUs";
import CTABanner from "@/components/CTABanner";

export default function ServicesPage() {
  return (
    <div data-testid="page-services">
      <PageHeader title="Services" />
      <Services />
      <WhyChooseUs />
      <CTABanner />
    </div>
  );
}
